import { boxShadowLevel2 } from '@issuu/ixu';
import { colorBaseGreyCool800, colorBaseWhite, layoutMarginSmall } from '@issuu/silkscreen';
import styled, { css } from 'styled-components';

import { breakpointWidths } from '../../constants';

export const MenuBox = styled.div<{ justifyRight?: boolean }>`
    position: absolute;
    @media (max-width: ${breakpointWidths.smallMax}px) {
        flex-direction: column;
        ${props =>
            props.justifyRight
                ? css`
                      right: 0;
                  `
                : css`
                      left: 0;
                  `}
        bottom: 1em;
        max-height: calc(100% - 2em);
    }
    @media (min-width: ${breakpointWidths.singleColMin}px) {
        ${props =>
            props.justifyRight
                ? css`
                      right: ${layoutMarginSmall};
                  `
                : css`
                      left: ${layoutMarginSmall};
                  `}
        bottom: 4em;
    }
    z-index: 2;
    background-color: ${colorBaseWhite};
    color: ${colorBaseGreyCool800};
    display: flex;
    box-shadow: ${boxShadowLevel2};
    border-radius: 0.5em;
    overflow: hidden;
    &:after {
        border-left: 0.5em solid transparent;
        border-right: 0.5em solid transparent;
        border-top: 0.5em solid #fff;
        content: '';
        position: absolute;
        left: 3em;
        bottom: -0.5em;
    }
`;
